import React from "react";

export type QuestionItem = {
  question: string;
  answer: string | null;
};

export type CategoryItem = {
  category: string;
  questions: QuestionItem[];
};

// API-аас ирсэн асуултын бүтэц
export type ApiQuestion = {
  id: number;
  categoryId: number;
  question: string;
  answerType: "radio" | "multi_select" | "text";
  options: string[] | null;
  order: number;
};

export type ApiCategory = {
  id: number;
  title: string;
  order: number;
  questions: ApiQuestion[];
};

type ApiFormProps = {
  category: ApiCategory;
  answers: Record<number, string | string[]>;
  setAnswers: React.Dispatch<React.SetStateAction<Record<number, string | string[]>>>;
};

export const DynamicFormApi = (props: ApiFormProps) => {
  const { category, answers, setAnswers } = props;

  const setAnswer = (questionId: number, value: string | string[]) => {
    setAnswers((prev) => ({ ...prev, [questionId]: value }));
  };

  return (
    <div className="space-y-6">
      <p className="text-[22px] font-semibold text-gray-800">{category.title}</p>

      {(category.questions || []).map((q, index) => (
        <div key={q.id} className="bg-gray-50 p-4 rounded-xl border border-gray-100">
          <p className="font-normal mb-3">
            {index + 1}. {q.question}
          </p>

          {q.answerType === "radio" && Array.isArray(q.options) && (
            <div className="flex flex-wrap gap-4">
              {q.options.map((opt) => (
                <label key={opt} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name={`q-${q.id}`}
                    className="h-5 w-5 text-amber-500"
                    checked={answers[q.id] === opt}
                    onChange={() => setAnswer(q.id, opt)}
                  />
                  <span>{opt}</span>
                </label>
              ))}
            </div>
          )}

          {q.answerType === "multi_select" && Array.isArray(q.options) && (
            <div className="flex flex-wrap gap-4">
              {q.options.map((opt) => {
                const current = (answers[q.id] as string[] | undefined) || [];
                const checked = current.includes(opt);
                return (
                  <label key={opt} className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      className="h-5 w-5 text-amber-500 rounded"
                      checked={checked}
                      onChange={() => {
                        const next = checked ? current.filter((x) => x !== opt) : [...current, opt];
                        setAnswer(q.id, next);
                      }}
                    />
                    <span>{opt}</span>
                  </label>
                );
              })}
            </div>
          )}

          {q.answerType === "text" && (
            <input
              type="text"
              value={(answers[q.id] as string) || ""}
              onChange={(e) => setAnswer(q.id, e.target.value)}
              placeholder="Гараар бичих..."
              className="w-full h-12 bg-white border border-gray-300 rounded-lg px-4 text-base focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none"
            />
          )}
        </div>
      ))}
    </div>
  );
};

// Хуучин JSON-д зориулсан (backward compatibility)
type Props = {
  categoryData: CategoryItem | null;
  setAllCategories: React.Dispatch<React.SetStateAction<CategoryItem[] | null>>;
};

export const DynamicForm = (props: Props) => {
  const { categoryData, setAllCategories } = props;

  const handleSelect = (questionIndex: number, value: number) => {
    if (!categoryData) return;

    setAllCategories((prev) => {
      if (!prev) return prev;
      const categoryIndex = prev.findIndex((cat) => cat.category === categoryData.category);
      if (categoryIndex === -1) return prev;
      const updated = [...prev];
      updated[categoryIndex] = {
        ...updated[categoryIndex],
        questions: updated[categoryIndex].questions.map((q, i) =>
          i === questionIndex ? { ...q, answer: value === 0 ? "тийм" : "үгүй" } : q
        ),
      };
      return updated;
    });
  };

  if (!categoryData) return null;

  return (
    <div className="space-y-4">
      <p className="text-[22px] font-semibold">{categoryData.category}</p>
      {categoryData.questions.map((q, index) => (
        <div key={index}>
          <p className="font-normal mb-2">
            {index + 1}. {q.question}
          </p>
          <div className="flex gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name={`question-${categoryData.category}-${index}`}
                className="h-5 w-5 text-amber-500"
                checked={q.answer === "тийм"}
                onChange={() => handleSelect(index, 0)}
              />
              <span>Тийм</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name={`question-${categoryData.category}-${index}`}
                className="h-5 w-5 text-amber-500"
                onChange={() => handleSelect(index, 1)}
                checked={q.answer === "үгүй"}
              />
              <span>Үгүй</span>
            </label>
          </div>
        </div>
      ))}
    </div>
  );
};
